export class Popup {
	applyActions(popup, mid, action, id) {
		popup.find(".data-replace-id").text(id)
		popup.find(".popup-confirm").off("click")
		popup.find(".popup-confirm").on("click", function() {
			$.ajax({
				url: "/ajax.php?mid=" + mid,
				type: "POST",
				data: { action: action, id: id },
				dataType: "json",
				success: function(res) {
					if (res["success"]) {
						$(".popup-cancelling__step").hide()
						$(".popup-cancelling__step.popup-cancelling__step--2").fadeIn()
					} else {
						alert("Ошибка: " + res["error"])
					}
				},
				error: function(res) {
					alert(
						"Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта"
					)
				},
			})
		})
	}

	showAuthPopup() {
		if (
			!window.matchMedia("(min-width: 1024px)").matches &&
			!$(".header__nav").hasClass("active")
		) {
			$("body").addClass("no-scroll")
			$(".header__nav").addClass("active")
			$(".header__menu-link--about").addClass("active")
			$(".about-popup").slideDown(300)
		}
		$(".header__profile-popup").fadeToggle()
	}

	sendVideoSubscride(parent) {
		let form = $(parent)
		$.ajax({
			url: "/ajax.php?mid=63",
			type: "POST",
			data: form.serialize() + "&action=vsub&clear=" + this.clear * 10,
			dataType: "json",
			success: function(res) {
				if (res.success) {
					$(".popup-masters__step--1").removeClass("active")
					$(".popup-masters__step--2").addClass("active")
				} else {
					alert("Ошибка: " + res["error"])
				}
			},
			error: function(res) {
				alert(
					"Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта"
				)
			},
		})
	}
}
